<template>
    <div>
        <app-modal class="newsletter-modal center-block" v-if="showModal" @close="showModal = false">
            <div class="row col-xs-12 text-left">
                <p class="pb-3" style="font-size: 30px; font-weight: 700; color: #333333;">
                    {{ $t('NEWSLETTER_AGREEMENT') }}
                </p>
                <p style="font-size: 16px;">{{ $t('NEWSLETTER_AGREEMENT_INFO') }}</p>
                <div class="text-center pt-2">
                    <span
                        style="cursor: pointer;color:#706C69"
                        @click="declineNewsletter"
                        class="-button-grey buttons-container__button"
                        >{{ $t('NO_I_DO_NOT_CONSENT') }}</span
                    >
                    <span
                        style="cursor: pointer"
                        @click="signUpNewsletter"
                        class="-button-red -small-button buttons-container__button mt-3"
                        >{{ $t('YES_I_CONSENT') }}</span
                    >
                </div>
            </div>
        </app-modal>
        <div class="container">
            <div class="grants-section">
                <div class="row row-flex">
                    <div class="col-xs-12 col-sm-3 col-md-2">
                        <img class="grants-img" src="../../../assets/images/footer-logo-pl.png" v-if="lang === 'pl'" />
                        <img class="grants-img" src="../../../assets/images/footer-logo-en.jpg" v-else />
                    </div>
                    <div class="grants-content col-xs-12 col-sm-6 col-md-8">
                        {{ $t('FOOTER_UE') }}<br />
                        {{ $t('FOOTER_UE_1') }}
                    </div>
                    <div class="col-xs-12 col-sm-3 col-md-2">
                        <img
                            class="grants-img footer-img"
                            src="../../../assets/images/footer-logo-ig-pl.png"
                            v-if="lang === 'pl'"
                        />
                        <img class="grants-img footer-img" src="../../../assets/images/footer-logo-ig-en.png" v-else />
                    </div>
                </div>
            </div>
        </div>
        <div class="app-footer__wrapper" style="direction: ltr !important;">
            <div class="container" style="max-width: 1220px;">
                <!--                <div class="app-footer pb-2">-->
                <!--                    <div class="row">-->
                <!--                        <div class="hidden-xs col-sm-9 pr-0">-->
                <!--                            <app-footer-menu></app-footer-menu>-->
                <!--                        </div>-->
                <!--                        <div class="help-line col-sm-3">-->
                <!--                            <ul class="help-line__column">-->
                <!--                                <li class="help-line__item&#45;&#45;first">{{ $t('INFOLINIA') }}</li>-->
                <!--                            </ul>-->
                <!--                            <ul class="help-line__column">-->
                <!--                                <li class="help-line__item">-->
                <!--                                    <span-->
                <!--                                        @click="redirectToSendingEmail"-->
                <!--                                        class="-button-grey buttons-container__button send-email-button"-->
                <!--                                    >-->
                <!--                                        {{ $t('SEND_EMAIL') }}-->
                <!--                                    </span>-->
                <!--                                </li>-->
                <!--                            </ul>-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                </div>-->
                <div class="black-bar__bottom">
                    <div style="display:flex;justify-content:space-between">
                        <p class="-small-paragraph -white-text">Copyright 2019 Braster S.A.</p>
                        <p class="-small-paragraph -white-text">
                            <a :href="eSklepUrl + $t('LINK_SYSTEM')" class="footer-menu__link">{{ $t('SYSTEM') }}</a>
                        </p>
                        <p class="-small-paragraph -white-text">
                            <a :href="eSklepUrl + $t('LINK_TERMS')" class="footer-menu__link">{{
                                $t('TERMS_AND_PRIVACY_POLICY')
                            }}</a>
                        </p>
                        <a
                            style="display: inline"
                            href="https://www.facebook.com/Braster.eu/"
                            target="_blank"
                            title="Facebook"
                            class="help-line__fb"
                        >
                            {{ $t('FACEBOOK') }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Modal from '../../modals/_modal.vue';
import FooterMenu from '../../shared/footer/footer-menu.vue';
import { config } from './../../../main';

export default {
    components: {
        appFooterMenu: FooterMenu,
        appModal: Modal,
    },
    data() {
        return {
            lang: this.$store.state.interfaceLanguage,
            email: '',
            formSubmitted: false,
            showModal: false,
            newsletterSubscribed: false,
            newsletterDeclined: false,
            selectedCampaign: 'Netherlands',
            campaigns: [
                { label: 'Netherlands', campaign_token: 0 },
                { label: 'Ireland', campaign_token: 0 },
                { label: 'Italy', campaign_token: 0 },
                { label: 'Japan', campaign_token: 0 },
                { label: 'UAE', campaign_token: 0 },
                { label: 'Other', campaign_token: 0 },
            ],
            emailRegex: config.emailRegex,
            eSklepUrl: config.eSklepUrl,
        };
    },
    methods: {
        redirectToSendingEmail() {
            location.href = config.eSklepUrl + this.$t('LINK_CONTACT_FORM');
        },
        openModal() {
            this.formSubmitted = true;
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.showModal = true;
                }
            });
        },
        declineNewsletter() {
            this.newsletterDeclined = true;
            this.newsletterSubscribed = false;
            this.showModal = false;
        },
        signUpNewsletter() {
            this.newsletterDeclined = false;
            this.newsletterSubscribed = true;
            this.showModal = false;
            this.$http.post(
                config.eSklepUrl + '/pl/mojekonto/api/NewsLetterSignUp',
                {
                    email: this.email,
                    campaign_token: this.lang === 'pl' ? 'j' : 0,
                },
                {
                    emulateJSON: true,
                },
            );
        },
    },
};
</script>

<style>
.grants-section {
    border-top: 1px solid #ede8e4;
    height: 140px;
    padding: 25px 15px;
}

.app-footer__wrapper {
    background: #2c2525;
}

.app-footer {
    color: #fff;
    margin: 0 auto;
    padding: 50px 15px;
}

.row-flex {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.row-flex > div {
    align-self: center;
    justify-content: center;
}

.footer-img {
    max-height: 88px;
    width: 100%;
}

.black-bar__bottom {
    padding: 20px 0;
    border-top: 1px solid rgba(77, 71, 69, 0.4);
}

.inner {
    max-width: 1170px;
    width: 92%;
    margin: 0 auto;
}

.-small-paragraph {
    font-size: 14px;
    line-height: 1rem;
    color: #fff;
}

.helpline__number {
    font-size: 28px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 0;
}

.helpline__mail {
    font-size: 19px;
    font-weight: 700;
    color: #fff;
}

.help-line__fb {
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    display: block;
    position: relative;
    white-space: nowrap;
    padding-left: 35px;
}

.help-line__fb:before {
    width: 26px;
    height: 26px;
    background: url('../../../assets/images/fb.png') center center no-repeat;
    background-size: cover;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0px;
    content: '';
}

@media (max-width: 991px) {
    .grants-section {
        height: auto;
    }

    .grants-content {
        margin: 20px 0;
    }

    .grants-img {
        width: auto;
        max-width: 100%;
        margin: 0 auto;
        display: block;
    }

    .helpline-section {
        margin-top: 30px;
    }
}

.black-bar__agreement-text {
    color: #fff;
    font-size: 12px;
}

@media only screen and (max-width: 990px) {
    .black-bar__agreement-text {
        font-size: 9px;
    }
}

@media only screen and (max-width: 767px) {
    .black-bar__agreement-text {
        font-size: 10px;
    }
}

.newsletter-info {
    font-size: 20px;
    font-weight: 700;
}

.newsletter-subscribed:before {
    content: '';
    position: absolute;
    top: 15%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    width: 40px;
    height: 40px;
    background: url('./../../../assets/images/excl-white.svg') no-repeat;
    background-size: cover;
    background-position: center;
}

.newsletter-declined:before {
    content: '';
    position: absolute;
    top: 15%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    width: 40px;
    height: 40px;
    background: url('./../../../assets/images/x_popup.svg') no-repeat;
    background-size: cover;
    background-position: center;
}

.newsletter-modal {
    max-width: 580px;
    position: fixed;
    top: 25%;
}

.newsletter-modal > .modal-content {
    padding: 30px;
}

.-button-red {
    background-color: #cf004a;
    color: #fff;
    border: 2px solid #cf004a;
}

.-button-red:hover {
    background-color: transparent;
    color: #cf004a;
}

.buttons-container__button {
    height: 50px;
    margin-right: 1.25rem;
    display: inline-block;
    font-weight: 700;

    border-radius: 6.25rem;
    text-align: center;
    outline: none;
    white-space: nowrap;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: background-color 0.25s ease-in-out, color 0.25s ease-in-out, border-color 0.25s ease-in-out;
    transition: background-color 0.25s ease-in-out, color 0.25s ease-in-out, border-color 0.25s ease-in-out;
    font-family: 'Ek Mukta', sans-serif;
}

@media only screen and (max-width: 767px) {
    .help-line__number {
        font-size: 1.2rem;
        font-weight: 700;
        color: #fff;
    }
}

@media only screen and (max-width: 989px) {
    .help-line__number {
        font-size: 1.2rem !important;
        font-weight: 700;
        color: #fff;
    }

    .help-line__column {
        list-style: none;
        padding-left: 0px;
    }

    .footer-menu__link {
        font-size: 10px;
    }
}

@media only screen and (max-width: 767px) {
    .help-line {
        margin-top: 0;
        width: 100%;
        -webkit-box-ordinal-group: 2;
        -ms-flex-order: 1;
        order: 1;
        margin-bottom: 1.875rem;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }
}

.help-line__item {
    text-align: left;
    margin-bottom: 0.625rem;
}

.help-line__item--first {
    color: #fff;
    text-transform: uppercase;
    font-weight: 800;
    font-size: 14px;
    margin-bottom: 0.625rem;
}

@media only screen and (max-width: 767px) {
    .help-line__item {
        width: 100%;
    }

    .help-line__item--first {
        font-size: 16px;
        margin-bottom: 0.625rem;
    }
}

.help-line__number {
    font-size: 1.6rem;
    font-weight: 700;
    color: #fff;
}

.send-email-button {
    white-space: initial !important;
    height: auto !important;
    padding-bottom: 13px !important;
    padding-top: 13px !important;
    line-height: 20px !important;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// the-footer.vue?25532ab9